<template>
  <el-dialog
    :visible.sync="showDialog"
    :before-close="handleClose"
    :width="modalWidth"
    top="10vh"
    custom-class="custom-scrollable"
    title="Select Currency/Country"
  >
    <div class="flex flex-col gap-4">
      <div>
        <div
          class="flex gap-2 px-4 h-14 border-main rounded-lg bg-white items-center"
        >
          <search-icon />
          <input
            class="focus:outline-none w-full h-14 bg-transparent"
            placeholder="Type a Currency / Country"
            :value="value"
            @input="onInput"
          />
          <!-- <div @click="clearSearchCountry" v-if="!!searchCountry">
            <close-icon color="#000" class="cursor-pointer" />
          </div> -->
        </div>
      </div>
      <div
        v-if="!isOptionsEmpty"
        class="flex gap-2 flex-col max-h-80 overflow-y-auto scrollbar"
      >
        <button
          v-for="(option, index) in options"
          :key="index"
          class="flex gap-2 p-2 items-center rounded-lg hover:bg-bg-muted"
          @click="handleOptionSelected(option)"
        >
          <currency-icons
            :currency="getCurrencyCountry(option.currency)"
            size="rounded-full h-6"
          />
          <span class="text-fg-default">{{ option.currency }}</span>
          <span class="text-fg-muted">{{ option.currencyFull }}</span>
        </button>
      </div>
      <div v-else class="select-main-container pb-8">
        <transaction-empty-state use="receive-payment">
          <h3 class="font-semibold text-root-2">No result found.</h3>
          <p
            class="font-light text-root-4 text-xs flex items-center justify-center mt-2"
          >
            <span class="w-3/4 text-center break-normal"
              >We cannot find the currency you are searching for, maybe a little
              spelling mistake?</span
            >
          </p>
        </transaction-empty-state>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { GetCurrencyCountry } from '@/utils/helpers'
import breakpoints from '@/utils/breakpoints.js'

export default {
  name: 'SearchableCurrencySelect',
  components: {
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    SearchIcon: () => import('@/assets/v2/icons/SearchIcon.vue'),
    // CloseIcon: () => import('@/assets/v2/icons/CloseIcon2.vue'),
    TransactionEmptyState: () =>
      import('@/components/empty-states/TransactionEmptyState.vue')
  },
  props: {
    value: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  emits: ['optionSelected', 'input', 'close'],
  data () {
    return {
      breakpoints
    }
  },
  methods: {
    handleOptionSelected (option) {
      this.$emit('optionSelected', option)
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    onInput (event) {
      this.$emit('input', event.target.value)
    },
    handleClose () {
      this.$emit('close')
    }
  },
  computed: {
    isOptionsEmpty () {
      return Array.isArray(this.options) && !this.options.length
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  }
}
</script>

<style scoped>
.scrollbar::-webkit-scrollbar-track {
  border-radius: 999px;
  background-color: transparent;
}

.scrollbar::-webkit-scrollbar {
  width: 5px;
  height: 0px;
  background-color: transparent;
}

.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background-color: var(--foreground-muted);
}
>>> .el-dialog {
  border-radius: 30px;
  padding: 20px;
}
>>> .el-dialog__body {
  padding: 0px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  /* padding: 25px; */
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}

>>> .el-dialog__header {
  padding-top: 0;
  text-align: center;
  padding-bottom: 24px;
}
</style>
